import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PushNotificationService } from 'src/app/services/push-notification.service';
import { CategoryService } from 'src/app/services/category.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class EditPushNotificationComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  disabled: boolean = true;
  pushNotificationForm: FormGroup;
  errorMessage = '';
  submitted = false;
  pagetitle: string;
  pushNotificationTypes: any = [];
  pushNotificationModules: any = [];
  pushNotificationAppTypes: any = [];
  item: any = [];
  id: string;
  notificationIconPreview: string | null = null;
  notificationIconFile: File | null = null;
  existingIconUrl: string | null = null;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropDialog: boolean = false;
  selectedFile: File | null = null;
  imageSize = 1000000;
  croppedImageMaxSize = 1000000;
  croppedImageSize = 0;
  croppedImageError: string | null = null;
  scale = 1;
  transform: ImageTransform = {};
  cropApplied = false;
  isApplyingCrop = false;

  constructor(private pushNotificationService: PushNotificationService, private formBuilder: FormBuilder, private messageService: MessageService,
    private router: Router, private activatedRoute: ActivatedRoute, private categoryService: CategoryService) { }

  async ngOnInit(): Promise<void> {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.pagetitle = 'Edit Notification';
    this.pushNotificationTypes = [
      { label: 'Push Notification', value: 'push notification' },
      { label: 'Website', value: 'website' }
    ];

    this.pushNotificationModules = [
      { label: 'Wallet', value: 'Wallet' },
      { label: 'FAP', value: 'FAP' },
      { label: 'Tournament', value: 'Tournament' },
      { label: 'Contest', value: 'Contest' },
    ];

    this.pushNotificationAppTypes = [
      { label: 'Player', value: 'Player' },
      { label: 'Academy', value: 'Academy' }
    ];

    this.pushNotificationForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern("^[A-Za-z0-9 '][A-Za-z0-9 ']*$")]],
      slug: ['', [Validators.required, Validators.pattern('^[A-Za-z_][A-Za-z_]*$')]],
      type: ['', [Validators.required]],
      description: ['', [Validators.required]],
      module: ['', [Validators.required]],
      appType: ['', [Validators.required]],
      notificationHeaderName: ['', [Validators.required]],
      notificationIcon: ['', [Validators.required]],
      status: [true]
    });

    this.getPushNotificationModules();
    setTimeout(()=>{
      this.getNotificationById(this.id);
    },1000);
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.pushNotificationForm.controls;
  }

  get cropDialogTitle(): string {
    return 'Crop & Adjust Notification Icon';
  }

  get cropDialogSubtitle(): string {
    return 'Position and scale your image for a 100 x 100 crop';
  }

  get cropPreviewLabel(): string {
    return '100 x 100 px - High Quality JPEG';
  }

    zoomIn() {
      this.scale += 0.1;
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    }

    zoomOut() {
      if (this.scale > 0.2) {
        this.scale -= 0.1;
        this.transform = {
          ...this.transform,
          scale: this.scale
        };
      }
    }

    resetZoom() {
      this.scale = 1;
      this.transform = {
        ...this.transform,
        scale: 1
      };
    }
    

  getPushNotificationModules() {
    const query = `?filterByParentCategory=pushNotificationModule`;
    this.categoryService.getCategoryList(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.pushNotificationModules = data?.data?.items;
    })
  }

  getNotificationById(id:string) {
    this.pushNotificationService.getPushNotificationById(id).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.pushNotificationForm.patchValue({
        name: data['name'],
        slug: data['slug'],
        type: this.pushNotificationTypes.find(ele => ele.value === data['type']),
        description: data['description'],
        module: this.pushNotificationModules.find(ele => ele.name === data['module']),
        appType: this.pushNotificationAppTypes.find(ele => ele.value === data['appType']),
        notificationHeaderName: data['notificationHeaderName'],
        notificationIcon: data['notificationIcon'],
        status: data['status']
      })
      // Set preview if icon exists - use notificationIconUrl for display
      if (data['notificationIconUrl']) {
        this.existingIconUrl = data['notificationIconUrl'];
        this.notificationIconPreview = data['notificationIconUrl'];
      }
      // Store the base64 icon data if exists
      if (data['notificationIcon']) {
        this.pushNotificationForm.patchValue({
          notificationIcon: data['notificationIcon']
        });
      }
    },err => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: err.error.message, life: 6000 });
    })
  }

  onSubmit() {
    this.submitted = true;
    if (this.pushNotificationForm.invalid) {
      return;
    }
    
    var pushNotificationFormData = this.pushNotificationForm.value;
    pushNotificationFormData['type'] = pushNotificationFormData['type'].value;
    pushNotificationFormData['module'] = pushNotificationFormData['module'].name;
    pushNotificationFormData['appType'] = pushNotificationFormData['appType'].value;

    pushNotificationFormData = JSON.stringify(pushNotificationFormData, null, 4);
    this.updateNotification(pushNotificationFormData);
  }

  updateNotification(pushNotificationFormData) {
    this.pushNotificationService.updatePushNotification(this.id, pushNotificationFormData).pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Push Notification Updated Successfully!!', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/manage/push-notification']);
        }, 2000);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Edit Push Notification failed', life: 6000 });
      })
    );
  }

  onReset() {
    this.submitted = false;
    this.pushNotificationForm.reset();
  }

  backLink() {
    this.router.navigate(['/manage/push-notification/']);
  }

  onFileSelect(event: any) {
    const file = event.target.files[0];
    if (!file) return;
    if (file.size > this.imageSize) {
      this.rejectOversizedImage();
      return;
    }
    this.cropApplied = false;
    this.isApplyingCrop = false;
    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = file;
    this.resetZoom();
    this.imageChangedEvent = {
      target: {
        files: [file]
      }
    };
    this.cropDialog = true;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
    this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
      ? 'Cropped image size must not exceed 1 MB.'
      : null;
  }

  onCropImageLoadFailed() {
    this.croppedImage = null;
    this.croppedImageSize = 0;
    this.croppedImageError = 'This image could not be loaded. Please choose a valid image file.';
  }
      
  getBase64SizeBytes(base64: string): number {
    if (!base64) return 0;
    return Math.round(
      (base64.length * (3 / 4)) -
      (base64.split(',')[0].length + 1)
    );
  }

  applyCrop() {
    if (this.isApplyingCrop || this.croppedImageError || !this.croppedImage || !this.selectedFile) return;
    this.isApplyingCrop = true;
    const file = this.base64ToFile(
      this.croppedImage,
      this.getOutputFileName(this.selectedFile.name)
    );
    if (file.size > this.croppedImageMaxSize) {
      this.croppedImageError = 'Cropped image size must not exceed 1 MB.';
      this.isApplyingCrop = false;
      return;
    }
    const event = {
      files: [file]
    };
    this.picUploader(event);
    this.cropApplied = true;
    this.cropDialog = false;
  }

  onCropCancel() {
    this.cropApplied = false;
    this.cropDialog = false;
  }

  onDialogHide() {
    this.resetCropState();
  }

  private resetCropState() {
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = null;
    this.cropApplied = false;
    this.isApplyingCrop = false;
    this.resetZoom();
  }

  private getOutputFileName(filename: string | undefined): string {
    const baseName = (filename || 'notification-icon').replace(/\.[^/.]+$/, '');
    return `${baseName}.jpg`;
  }
      
  rejectOversizedImage() {
    this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 1 MB', life: 6000 });
    this.onCropCancel();
  } 

  base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  picUploader(event: any) {
    const file = event.files[0];
    if (file) {
      // Validate file type
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Invalid File Type', detail: 'Please upload a valid image file (JPEG, PNG, GIF, WEBP)', life: 6000 });
        return;
      }

      // Validate file size (max 2MB)
      if (file.size > 2 * 1024 * 1024) {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 2MB', life: 6000 });
        return;
      }

      this.notificationIconFile = file;
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        this.notificationIconPreview = base64String;
        this.pushNotificationForm.patchValue({
          notificationIcon: base64String
        });
      };
      reader.readAsDataURL(file);
    }
  }

  removeIcon() {
    this.notificationIconPreview = this.existingIconUrl;
    this.notificationIconFile = null;
    // Reset to existing icon data if available
    if (this.existingIconUrl) {
      this.notificationIconPreview = this.existingIconUrl;
    } else {
      this.pushNotificationForm.patchValue({
        notificationIcon: ''
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
